import { render, staticRenderFns } from "./taobao_shangou_qun.vue?vue&type=template&id=448bac7a&scoped=true&"
import script from "./taobao_shangou_qun.vue?vue&type=script&lang=js&"
export * from "./taobao_shangou_qun.vue?vue&type=script&lang=js&"
import style0 from "./taobao_shangou_qun.vue?vue&type=style&index=0&id=448bac7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448bac7a",
  null
  
)

export default component.exports